import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CotizacionesService } from '../../Service/cotizaciones-service';
import { RecepcionesService } from '../../Service/recepciones-service'; // 🚀 Inyectado para jalar el croquis original
import { ToastService } from '../../Service/toast-service';
import { Cotizacion } from '../../Cotizacion/models/cotizacion';
import { DomSanitizer } from '@angular/platform-browser'; // 🚀 INYECTADO

@Component({
  selector: 'app-cotizacion-remota',
  standalone: true,
  imports: [CommonModule, FormsModule, HttpClientModule],
  templateUrl: './cotizacion-remota.html',
  styleUrl: './cotizacion-remota.css',
})
export class CotizacionRemota implements OnInit {
  public token: string = '';
  public cotizacion: Cotizacion | null = null;
  public comentariosRechazo: string = '';
  public cargando: boolean = true;
  public procesadoExito: boolean = false;
  public estatusFinalMsg: string = '';

  // 🚀 VARIABLES EXPLICITAS INYECTADAS (Limpian el error ts(2339) de raíz)
  public currentVehicleSvg: string = 'images/croquis-sedan.svg';
  public datosCarroceriaPatio: any[] = [];

  // 🚀 VARIABLES INYECTADAS PARA LA GALERÍA DE EVIDENCIAS REMOTAS
  public data: any = { fotos: [] };
  public mostrarVisorFotos: boolean = false;
  public indiceFotoActual: number = 0;  

  // 🚀 URL DEL SERVIDOR PÚBLICO: Cambia localhost por tu IP pública o dominio de producción cuando salgas a la nube
  private readonly URL_CONCTADO_ARCHIVOS = '/uploads/';

  private mapperCarroceria: { [key: string]: string } = {
    'Sedán': 'sedan', 
    'Pickup': 'pickup', 
    'SUV': 'suv', 
    'Camión': 'camion', 
    'Autobús': 'autobus'
  };

  // 🚀 VARIABLES PARA GESTOS TÁCTILES (SWIPE MÓVIL)
  private touchStartX: number = 0;
  private touchEndX: number = 0;
  private readonly MIN_SWIPE_DISTANCE = 40; // Distancia mínima en píxeles para activar el cambio  

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cotizacionesService: CotizacionesService,
    private recepcionesService: RecepcionesService, // Inyectado    
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer // 🚀 INYECTADO EN EL CONSTRUCTOR
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.params['token'];
    if (!this.token) {
      this.toastService.showDanger('Enlace Roto', 'Token de seguridad no suministrado.');
      this.cargando = false;
      return;
    }
    this.cargarPresupuestoRemoto();
  }

  private cargarPresupuestoRemoto(): void {
    console.log('🛰️ [SaaS Móvil] 1. Descargando expediente ligero mediante Token SHA-256...');
    
    this.cotizacionesService.obtenerPresupuestoPublicoPorToken(this.token).subscribe({
      next: (c: Cotizacion) => {
        if (!c) {
          this.cargando = false;
          this.toastService.showDanger('Error', 'No se localizó el presupuesto comercial.');
          return;
        }

        this.cotizacion = c;
        
        if (c.estatusAprobacion !== 'Pendiente' && c.estatusAprobacion !== null) {
          this.procesadoExito = true;
          this.estatusFinalMsg = `Este presupuesto ya fue procesado previamente con estatus: ${c.estatusAprobacion?.toUpperCase()}`;
          this.cargando = false;
          this.cdr.detectChanges();
          return;
        }

        // 🚀 OBLIGAMOS A ENTRAR AL CONTENEDOR MEDIANTE EL TEMPORIZADOR
        setTimeout(() => {
          // 🔬 LOGS DE TELEMETRÍA EN CALIENTE PARA INSPECCIÓN EN CHROME F12
          console.log('🔬 [SaaS TELEMETRÍA FRONTEND] JSON recibido de la API Pública:', c);
          console.log('🔬 [SaaS TELEMETRÍA FRONTEND] Atributo tipoSilueta:', c.tipoSilueta);
          console.log('🔬 [SaaS TELEMETRÍA FRONTEND] Arreglo detallesCarroceriaGrid (Pines):', (c as any).detallesCarroceriaGrid);

          // =========================================================================
          // 🚀 EXTRAER Y SANITIZAR LAS FOTOS DEL PAYLOAD REMOTO
          // =========================================================================
          const fotosCrudas = (c as any).fotos || [];
          if (fotosCrudas && fotosCrudas.length > 0) {
            console.log('📥 [SaaS Fotos Remotas] Evidencias fotográficas localizadas:', fotosCrudas);
            this.data = {
              fotos: fotosCrudas.map((f: any) => {
                const archivoNombre = f.urlFoto || f.nombreFoto || '';
                const rutaCompleta = `${this.URL_CONCTADO_ARCHIVOS}${archivoNombre}`;
                return {
                  ...f,
                  urlSanitizada: archivoNombre 
                    ? this.sanitizer.bypassSecurityTrustUrl(rutaCompleta)
                    : 'images/default-placeholder.jpg'
                };
              })
            };
            console.log(`✅ [SaaS Fotos SUCCESS] Galería cargada en móvil. Total: ${this.data.fotos.length}`);
          } else {
            console.warn('⚠️ [SaaS Fotos Remotas] El JSON público de esta cotización no contiene evidencias fotográficas.');
            this.data = { fotos: [] };
          }

          // Resguardamos los pines mapeados de forma segura utilizando aserción de tipo para evitar el error ts(2339)
          const pinesCrudos = (c as any).detallesCarroceriaGrid || (c as any).detallesCarroceria || [];
          this.datosCarroceriaPatio = pinesCrudos ? [...pinesCrudos] : [];
          
          // 🔮 RESOLUCIÓN DINÁMICA DE SILUETA EXACTA (Evaluación directa en la raíz)
          const siluetaBase = c.tipoSilueta || (c as any).tipo_silueta || 'Sedán';
          
          console.log(`🔬 [SaaS TELEMETRÍA FRONTEND] Palabra clave de silueta enviada al Mapper: [${siluetaBase}]`);

          const nombreArchivoSvg = this.mapperCarroceria[siluetaBase] || 'sedan';
          this.currentVehicleSvg = `images/croquis-${nombreArchivoSvg}.svg`;
          
          console.log(`✅ [SaaS Móvil SUCCESS] Silueta final asignada: ${this.currentVehicleSvg}. Total de pines: ${this.datosCarroceriaPatio.length}`);

          this.cargando = false;
          this.cdr.markForCheck();
          this.cdr.detectChanges(); // Fuerza a Angular a pintar los puntos de daño sobre el celular del cliente
        }, 0);
      },
      error: (err) => {
        console.error('❌ Error en canal público de red:', err);
        this.cargando = false;
        this.toastService.showDanger('Fallo de Conexión', 'No se pudo sincronizar el canal anónimo.');
      }
    });
  }

  public responderPresupuesto(accion: 'APROBAR' | 'RECHAZAR'): void {
    if (accion === 'RECHAZAR' && !this.comentariosRechazo.trim()) {
      alert('Por favor, indique brevemente el motivo del rechazo.');
      return;
    }

    this.cargando = true;
    const arrayPartidas = this.cotizacion?.lineas || [];

    // Despachamos la acción pasando las líneas para guardar el estatus de los checkboxes
    this.cotizacionesService.procesarAprobacionRemota(this.token, accion, this.comentariosRechazo, arrayPartidas).subscribe({
      next: () => {
        this.procesadoExito = true;
        this.estatusFinalMsg = accion === 'APROBAR' 
          ? '🎉 ¡Gracias! Tu presupuesto ha sido autorizado de forma digital. El taller iniciará la reparación de inmediato.'
          : '⚠️ Presupuesto rechazado. Un asesor comercial se comunicará contigo para ajustar los conceptos.';
        this.cargando = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.cargando = false;
        alert(err.error?.error || 'No se pudo procesar la respuesta comercial.');
      }
    });
  }

  public recalcularTotalesRemotos(): void {
    if (!this.cotizacion || !this.cotizacion.lineas) return;

    let subtotalAcumulado = 0;
    this.cotizacion.lineas.forEach(l => {
      if (l.aprobadoPorCliente) {
        subtotalAcumulado += l.subtotalLinea || 0;
      }
    });

    // Re-calculamos el IVA y el gran total en caliente sobre el smartphone
    this.cotizacion.subtotal = +subtotalAcumulado.toFixed(2);
    this.cotizacion.iva = +(subtotalAcumulado * 0.16).toFixed(2);
    this.cotizacion.total = +(subtotalAcumulado * 1.16).toFixed(2);
    this.cdr.detectChanges();
  }

  public navegarFoto(direccion: number): void {
    if (!this.data.fotos || this.data.fotos.length === 0) return;
    const nuevoIndice = this.indiceFotoActual + direccion;
    
    if (nuevoIndice >= 0 && nuevoIndice < this.data.fotos.length) {
      this.indiceFotoActual = nuevoIndice;
      this.cdr.detectChanges();
    }
  }

  // 📥 CAPTURA EL TOQUE (CORREGIDO: Leemos el primer dedo del arreglo con)
  public onTouchStart(event: TouchEvent): void {
    if (event.touches && event.touches.length > 0) {
      this.touchStartX = event.touches[0].clientX; // 🎯 Corrección crítica
    }
  }

  // 📤 EVALÚA EL FINAL DEL TOQUE (CORREGIDO: Leemos el primer dedo del arreglo con)
  public onTouchEnd(event: TouchEvent): void {
    if (event.changedTouches && event.changedTouches.length > 0) {
      this.touchEndX = event.changedTouches[0].clientX; // 🎯 Corrección crítica
      this.procesarGestoSwipe();
    }
  }

  private procesarGestoSwipe(): void {
    const distanciaRecorrida = this.touchStartX - this.touchEndX;

    if (Math.abs(distanciaRecorrida) > this.MIN_SWIPE_DISTANCE) {
      if (distanciaRecorrida > 0) {
        this.navegarFoto(1);  // Avanzar a la siguiente foto
      } else {
        this.navegarFoto(-1); // Retroceder a la foto anterior
      }
    }
  }
  
}
